export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrée :"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continuer"])}
}